export default __webpack_public_path__ + "static/media/about1.c92d17b4.jpg";